import React from 'react';
import './shimmerLoader.scss';

export const ShimmerLoader: React.FC = () => {

  return (
    <div className="overlay" style={{zIndex: 1067}}>
     <div
        className="fm-spinner p-3 d-flex justify-content-center align-items-center rounded-circle"
      >
        <img src="../../assets/images/fm-logo-icon.png" alt="" className="h-100" />
      </div>
    </div>
  );
};